/*
  Выбор оператора рассылки - выпадающим списком, а не полем ввода.

  02.10.2026, решение владельца: «так мы жёстко говорим, что поддерживаем». В
  свободное поле вписывали что угодно, и опечатка всплывала только на волне,
  когда ссылки уже выданы. Перечень присылает сервер - тот же, по которому он
  выбирает шлюз отправки и проверяет форму, - поэтому новый оператор появится
  здесь сам.

  Своя подпись, а не `Field`: разметка выпадающего списка - кнопка, и обёртка
  `<label>` её не называет; читалке имя даётся ссылкой (правило 6в скилла
  `frontend`, тот же приём, что в `CourtForm.jsx`).

  Значение, внесённое раньше вручную и в перечень не входящее, показывается как
  «не выбран»: подставлять похожее молча нельзя, а сохранить незнакомое сервер
  всё равно не даст.
*/

import InfoHint from './InfoHint.jsx'
import Dropdown from './Select.jsx'

export default function SmsProviderField({ value, onChange, providers, error }) {
  // Пояснение - под значком «i», как у остальных полей (`Field`, 02.10.2026).
  return (
    <div className={`field field--m field--hinted${error ? ' field--invalid' : ''}`}>
      <span className="field__label" id="sms-provider-label">
        Оператор рассылки
      </span>
      <InfoHint text="Нужен оператор, которого нет в списке, - сообщите в поддержку Арбитра ЖКХ." />
      <Dropdown
        value={value}
        onChange={onChange}
        options={providers}
        empty="не выбран"
        labelledBy="sms-provider-label"
      />
      {error ? (
        <span className="field__error" id="sms-error-provider">
          {error}
        </span>
      ) : null}
    </div>
  )
}
